import React from 'react'

import { Container, ContentHeader } from 'components'
import { TabContainer, TabItem } from 'components/Tab'
import TabProvider from 'providers/TabProvider'
import TabLogAction from './components/TabLogAction'
import TabLogAudited from './components/TabLogAudited'

const Page = ({ title, subtitle, entity, entityId }) => {
  return (
    <Container>
      <ContentHeader title={title} subtitle={subtitle} />

      <TabProvider defaultValue="actions">
        <TabContainer orientation="horizontal">
          <TabItem label="Logs de ação" value="actions">
            <TabLogAction entity={entity} entityId={entityId} />
          </TabItem>

          <TabItem label="Logs de auditoria" value="audits">
            <TabLogAudited entity={entity} entityId={entityId} />
          </TabItem>
        </TabContainer>
      </TabProvider>
    </Container>
  )
}

export default Page
